import { useParams } from "react-router-dom";
import Profile from "@/pages/Profile";

export default function AdminEditMember() {
  const { id } = useParams();
  return <Profile key={id} adminMemberId={id} />;
}
